import React, { useEffect, useState } from "react";
import Header from "../../Components/Header"; // Adjust the path as necessary
import Footer from "../../Components/Footer";
import pricingData from '../../Data/pricingData.json';
import { membershipApis } from '../../Data/axios';
import FadeInSection from '../../Components/FadeInSection';
import Banner from '../../Components/Banner';

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        setLoading(true);
        const response = await membershipApis.getAllWeb(1,14);
        console.log("API.data Response:", response.data);
        console.log("API Response:", response);
        setPlans(response.data);
      } catch (err) {
        setError("Failed to fetch memberships");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMemberships();
  }, []);
  return (
    <>
    <div className="bg-topo-bg font-ubuntu">
      <Header />
      <Banner 
        imageUrl="./banner1.svg"
        title="Our Pricing Plan"
        subtitle="Explore flexible pricing options tailored to suit your needs." />
      <section className="relative z-10 overflow-hidden font-ubuntu pb-12 pt-10 lg:pb-[90px] lg:pt-[100px]">
        <div className="container mx-auto">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : (
            <div className="-mx-4 flex flex-wrap justify-center">
              
              {plans.map((plan,index) => (
                

                <PricingCard
                  key={plan.id}
                  type={plan.membership}
                  validity={plan.validity}
                  price={`₹${plan.price}`}
                  features={plan.lists}
                />

              ))}
              
              
            </div>
          )}
        </div>
      </section>
    </div>
    <Footer />
    </>
  );
};

export default Pricing;

const PricingCard = ({
  type,
  price,
  features,
  validity
}) => {
  return (
    // <FadeInSection animationType="up" csClass="">
    <div className="w-full px-4 md:w-1/2 lg:w-1/3 mb-8">
      <FadeInSection animationType="up" csClass="">
      <div className="relative flex flex-col h-full rounded-xl border-2 border-stroke bg-white px-6 py-8 shadow-lg sm:px-8 sm:py-10 lg:px-6 lg:py-8 xl:px-10 xl:py-10">
        <div className="flex-grow">
          <span className="mb-3 block text-lg font-semibold text-primary">
            {type}
          </span>
          <h2 className="mb-5 text-4xl font-bold text-dark">
            {price}
            <span className="text-base font-semibold text-body-color">
              / {validity} days
            </span>
          </h2>
          <p className="mb-8 border-b border-stroke pb-8 text-base text-body-color">
            {/* Perfect For {type} */}
          </p>
          <ul className="mb-8 pb-8 text-base text-body-color space-y-3 pl-0">
            {features.length > 0 ? (
              features.map((feature) => (
                <li key={feature.id} className="pl-0">{feature.text}</li>
              ))
            ) : (
              <li>No features available</li>
            )}
          </ul>
        </div>
        <button className="mt-auto block w-full rounded-md border border-primary bg-csyellow p-3 text-center text-base font-medium text-white transition hover:bg-opacity-90">
          Choose {type}
        </button>
        
        {/* Decorative SVG elements */}
        <span className="absolute right-0 top-7 z-20">
          <svg
            width={77}
            height={172}
            viewBox="0 0 77 172"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx={86} cy={86} r={86} fill="url(#paint0_linear)" />
            <defs>
              <linearGradient
                id="paint0_linear"
                x1={86}
                y1={0}
                x2={86}
                y2={172}
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#f7c602" stopOpacity="0.09" />
                <stop offset={1} stopColor="#C4C4C4" stopOpacity={0} />
              </linearGradient>
            </defs>
          </svg>
        </span>
        <span className="absolute right-4 top-4 z-20">
          <svg
            width={41}
            height={89}
            viewBox="0 0 41 89"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="38.9138"
              cy="87.4849"
              r="1.42021"
              transform="rotate(180 38.9138 87.4849)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="74.9871"
              r="1.42021"
              transform="rotate(180 38.9138 74.9871)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="62.4892"
              r="1.42021"
              transform="rotate(180 38.9138 62.4892)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="38.3457"
              r="1.42021"
              transform="rotate(180 38.9138 38.3457)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="13.634"
              r="1.42021"
              transform="rotate(180 38.9138 13.634)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="50.2754"
              r="1.42021"
              transform="rotate(180 38.9138 50.2754)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="26.1319"
              r="1.42021"
              transform="rotate(180 38.9138 26.1319)"
              fill="#f7c602"
            />
            <circle
              cx="38.9138"
              cy="1.42021"
              r="1.42021"
              transform="rotate(180 38.9138 1.42021)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="87.4849"
              r="1.42021"
              transform="rotate(180 26.4157 87.4849)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="74.9871"
              r="1.42021"
              transform="rotate(180 26.4157 74.9871)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="62.4892"
              r="1.42021"
              transform="rotate(180 26.4157 62.4892)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="38.3457"
              r="1.42021"
              transform="rotate(180 26.4157 38.3457)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="13.634"
              r="1.42021"
              transform="rotate(180 26.4157 13.634)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="50.2754"
              r="1.42021"
              transform="rotate(180 26.4157 50.2754)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="26.1319"
              r="1.42021"
              transform="rotate(180 26.4157 26.1319)"
              fill="#f7c602"
            />
            <circle
              cx="26.4157"
              cy="1.4202"
              r="1.42021"
              transform="rotate(180 26.4157 1.4202)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="87.4849"
              r="1.42021"
              transform="rotate(180 13.9177 87.4849)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="74.9871"
              r="1.42021"
              transform="rotate(180 13.9177 74.9871)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="62.4892"
              r="1.42021"
              transform="rotate(180 13.9177 62.4892)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="38.3457"
              r="1.42021"
              transform="rotate(180 13.9177 38.3457)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="13.634"
              r="1.42021"
              transform="rotate(180 13.9177 13.634)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="50.2754"
              r="1.42021"
              transform="rotate(180 13.9177 50.2754)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="26.1319"
              r="1.42021"
              transform="rotate(180 13.9177 26.1319)"
              fill="#f7c602"
            />
            <circle
              cx="13.9177"
              cy="1.42019"
              r="1.42021"
              transform="rotate(180 13.9177 1.42019)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="87.4849"
              r="1.42021"
              transform="rotate(180 1.41963 87.4849)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="74.9871"
              r="1.42021"
              transform="rotate(180 1.41963 74.9871)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="62.4892"
              r="1.42021"
              transform="rotate(180 1.41963 62.4892)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="38.3457"
              r="1.42021"
              transform="rotate(180 1.41963 38.3457)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="13.634"
              r="1.42021"
              transform="rotate(180 1.41963 13.634)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="50.2754"
              r="1.42021"
              transform="rotate(180 1.41963 50.2754)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="26.1319"
              r="1.42021"
              transform="rotate(180 1.41963 26.1319)"
              fill="#f7c602"
            />
            <circle
              cx="1.41963"
              cy="1.4202"
              r="1.42021"
              transform="rotate(180 1.41963 1.4202)"
              fill="#f7c602"
            />
          </svg>
        </span>
      </div>
      </FadeInSection>
    </div>
    
  );
};